export default __webpack_public_path__ + "static/Google_Analytics_new_reporting-e74c2f114c460385f687a6c9b0038d59.gif";